module.exports = __webpack_public_path__ + "img/workstation-baseline.7ac23253.png";